import axios from 'axios';

// API клиент — прямая связь с казино. 📞
// По умолчанию '/api' — Vite-прокси перенаправит на backend (см. vite.config.ts).
const apiUrl = import.meta.env.VITE_API_URL || '/api';

export const apiClient = axios.create({
  baseURL: apiUrl,
  headers: { 'Content-Type': 'application/json' },
});

// Токен держим в модуле и подставляем интерсептором — не таскаем по всем вызовам.
let authToken: string | null = null;
export function setAuthToken(token: string | null) {
  authToken = token;
}
export function getAuthToken(): string | null {
  return authToken;
}

apiClient.interceptors.request.use((config) => {
  if (authToken) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  return config;
});

// На 401 (протухший/невалидный токен) — дёргаем колбэк (чистка сессии + ре-авторизация).
let onUnauthorized: (() => void) | null = null;
export function setOnUnauthorized(cb: () => void) {
  onUnauthorized = cb;
}
apiClient.interceptors.response.use(
  (r) => r,
  (err) => {
    const url: string = err?.config?.url || '';
    if (err?.response?.status === 401 && !url.includes('/auth/')) {
      onUnauthorized?.();
    }
    return Promise.reject(err);
  }
);
